import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { shareContent } from '../../utils/shareUtils';
import './BlogEventPage.css';

const BlogEventPage = () => {
  const navigate = useNavigate();
  const [shareMessage, setShareMessage] = useState('');

  // 채널톡 열기 함수
  const openChannelTalk = () => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'blog_apply_click', {
        event_category: 'Events',
        event_label: 'blog_detail_page',
        value: 1
      });
    }

    if (window.ChannelIO) {
      window.ChannelIO('show');
    } else {
      window.location.href = 'mailto:angel@plactical.com?subject=[블로그 포스팅 이벤트] 왓퀴즈 사용 후기 포스팅';
    }
  };

  const goBack = () => {
    navigate('/events');
  };

  // 이벤트 공유 함수
  const handleShareEvent = async () => {
    const shareData = {
      title: '왓퀴즈 블로그 포스팅 이벤트 - 신세계 상품권 1만원!',
      text: '왓퀴즈 블로그 후기를 작성하고 신세계 상품권 1만원을 받아보세요! 교사용 AI 플랫폼',
      url: `${window.location.origin}/events/blog`
    };

    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'blog_share_click', {
        event_category: 'Events',
        event_label: 'blog_page_share',
        value: 1
      });
    }

    const result = await shareContent(shareData);
    
    if (result.success) {
      setShareMessage('이벤트가 공유되었습니다!');
    } else if (result.error) {
      setShareMessage(result.error.includes('복사') ? 'URL이 복사되었습니다!' : '공유에 실패했습니다.');
    }

    setTimeout(() => setShareMessage(''), 3000);
  };

  const benefits = [
    {
      title: '신세계 상품권 1만원',
      description: '포스팅 승인 시 즉시 지급'
    },
    {
      title: 'PRO 30일 이용권',
      description: '계정 확인 후 바로 적용'
    },
    {
      title: '다른 이벤트 중복 참여',
      description: '커뮤니티, 인터뷰, 추천 등 모두 참여 가능'
    }
  ];

  const guideItems = [
    { label: '텍스트', value: '1,000자 이상' },
    { label: '사용 화면', value: '스크린샷 10장 이상' },
    { label: '링크', value: 'whatquiz.co.kr 삽입' },
    { label: '키워드', value: '왓퀴즈, 교사용GPT, AI생기부작성' },
    { label: '내용', value: '실제 활용 후기, 팁, 노하우' }
  ];

  const excellentBlogs = [
    {
      teacher: '링링쌤',
      url: 'https://blog.naver.com/eduteacher_0502/223875424474',
      title: '왓퀴즈 활용 후기'
    },
    {
      teacher: '좋아유쌤',
      url: 'https://blog.naver.com/coreashine/223920528130',
      title: '좋아유쌤의 경제 교실'
    },
    {
      teacher: '설티쌤',
      url: 'https://blog.naver.com/engsulin/223928421821',
      title: '영어 수업 활용 사례'
    }
  ];

  return (
    <div className="blog-event-page">
      <Helmet>
        <title>리뷰 작성 이벤트 - 왓퀴즈</title>
        <meta name="description" content="왓퀴즈 사용 후기를 블로그에 포스팅하고 신세계 상품권 1만원을 받으세요!" />
        <meta property="og:title" content="블로그 포스팅 이벤트 - 왓퀴즈" />
        <meta property="og:description" content="왓퀴즈 사용 후기를 블로그에 포스팅하고 신세계 상품권 1만원을 받으세요!" />
      </Helmet>

      {/* 헤더 섹션 */}
      <section className="blog-header">
        <div className="container">
          <button className="back-button" onClick={goBack}>
            ← 이벤트 목록
          </button>
          
          <div className="page-title-section">
            <div className="blog-icon-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 20h9"></path>
                <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
              </svg>
            </div>
            <h1 className="blog-title">리뷰 작성 이벤트</h1>
            <p className="blog-subtitle">블로그에 사용 후기를 작성하고 리워드를 받으세요</p>
          </div>
        </div>
      </section>

      {/* 혜택 섹션 - Value First */}
      <section className="blog-benefits">
        <div className="container">
          <h2>참여 혜택</h2>
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-card">
                <span className="benefit-num">{index + 1}</span>
                <h3 className="benefit-title">{benefit.title}</h3>
                <p className="benefit-description">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 작성 가이드 섹션 */}
      <section className="blog-guide">
        <div className="container">
          <h2>작성 가이드</h2>
          <div className="guide-list">
            {guideItems.map((item, index) => (
              <div key={index} className="guide-item">
                <span className="guide-label">{item.label}</span>
                <span className="guide-value">{item.value}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 우수 리뷰 예시 섹션 */}
      <section className="blog-examples">
        <div className="container">
          <h2>선생님들의 리뷰</h2>
          <p className="examples-desc">실제 활용 후기를 참고해보세요</p>
          <div className="examples-grid">
            {excellentBlogs.map((blog, index) => (
              <div key={index} className="example-card">
                <h3 className="example-teacher">{blog.teacher}</h3>
                <p className="example-title">{blog.title}</p>
                <a 
                  href={blog.url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="example-link"
                >
                  블로그 보러가기 →
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA 섹션 */}
      <section className="blog-apply">
        <div className="container">
          <div className="apply-content">
            <h2>지금 바로 참여하세요</h2>
            <p>
              포스팅 완료 후 채널톡으로 링크를 보내주시면<br/>
              검토 후 3일 내 상품권을 발송해드려요
            </p>
            
            <div className="apply-info">
              <div className="info-item">
                <strong>참여 방법</strong>
                <span>채널톡으로 포스팅 링크 제출</span>
              </div>
              <div className="info-item">
                <strong>심사 기준</strong>
                <span>글자 수, 이미지, 링크, 키워드</span>
              </div>
              <div className="info-item">
                <strong>리워드 발송</strong>
                <span>승인 후 3일 내 카카오톡 발송</span>
              </div>
            </div>

            <div className="button-group">
              <button className="apply-button" onClick={openChannelTalk}>
                리뷰 이벤트 신청하기
              </button>
              
              <button className="share-button" onClick={handleShareEvent}>
                이벤트 공유하기
              </button>
            </div>

            {shareMessage && (
              <div className="share-message">
                {shareMessage}
              </div>
            )}

            <p className="apply-note">
              * 승인 후 3일 내 개별 연락드립니다
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogEventPage;
